import { connectRouter, RouterState } from 'connected-react-router';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { authReducer, AuthState } from 'state/auth/auth.reducer';
import { PersistState } from 'redux-persist/es/types';
import { createOptionalTransform } from '@summer/react-kit';
import { History } from 'history';

interface PersistPartial {
  _persist: PersistState;
}

export interface AppState {
  auth: AuthState & PersistPartial;
  router: RouterState;
}

export const createRootReducer = (history: History) =>
  combineReducers<AppState>({
    auth: persistReducer(
      {
        storage: storageSession,
        key: 'auth',
        whitelist: ['token', 'username'],
        transforms: [createOptionalTransform(['token'])],
      },
      authReducer
    ),
    router: connectRouter(history),
  });
